import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LINKS } from "@/lib/constants";

const navItems = [
  { label: "Leistungen", href: "#leistungen", testid: "leistungen" },
  { label: "Galerie", href: "#galerie", testid: "galerie" },
  { label: "Über uns", href: "#ueber-uns", testid: "ueberuns" },
  { label: "Kontakt", href: "#kontakt", testid: "kontakt" },
];

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <header
        data-testid="main-navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${scrolled ? "nav-glass py-4" : "bg-transparent py-6"}`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between">
          <a href="#top" data-testid="nav-logo" className="font-display text-2xl font-bold gold-text tracking-wide">
            NABIL
          </a>
          <nav className="hidden lg:flex items-center gap-10">
            {navItems.map((item) => (
              <a key={item.href} href={item.href} className="nav-link" data-testid={`nav-link-${item.testid}`}>
                {item.label}
              </a>
            ))}
            <a href={LINKS.fresha} target="_blank" rel="noopener noreferrer" className="btn-gold !py-3 !px-6 !text-xs" data-testid="nav-booking-cta">
              Termin buchen
            </a>
          </nav>
          <button
            data-testid="mobile-menu-button"
            className="lg:hidden gold-text"
            onClick={() => setOpen(true)}
            aria-label="Menü öffnen"
          >
            <Menu size={28} />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-[70] flex flex-col items-center justify-center"
            style={{ background: "rgba(8,8,8,0.98)" }}
          >
            <button
              data-testid="mobile-menu-close"
              className="absolute top-6 right-6 gold-text"
              onClick={() => setOpen(false)}
              aria-label="Menü schließen"
            >
              <X size={32} />
            </button>
            <nav className="flex flex-col items-center gap-8">
              {navItems.map((item, i) => (
                <motion.a
                  key={item.href}
                  href={item.href}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.1 + i * 0.08 }}
                  onClick={() => setOpen(false)}
                  className="font-display text-3xl gold-text"
                >
                  {item.label}
                </motion.a>
              ))}
              <motion.a
                href={LINKS.fresha}
                target="_blank"
                rel="noopener noreferrer"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="btn-gold mt-4"
              >
                Termin buchen
              </motion.a>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
